import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { EXIT_MODAL_CAMBIO_VIA_PAGO, EXIT_MODAL_CONGELAMIENTO_SALDOS, EXIT_MODAL_DATOS_PERSONALES, MensajeSalidaFlujoTramitePension, TipoMensajeSalidaFlujoTramitePension } from '@constants/business.constant';
import { BENEFICIARIES, DATA_UPDATE, FUND_CHANGE_URL, HOME_URL, INICIO, ONBOARDING, PROFILE, ROUTING_CAMBIO_VIA_PAGO_PENSION, ROUTING_CONGELAMIENTOS_SALDOS, TRANSACTIONS, URL_ESTIMADOR_PENSION, VIDEO_ATENCION } from "@constants/url.constant";
import { IGenericModal, IInformationModal } from "@interfaces/modal.interface";
import { ModalController, ModalOptions } from "@ionic/angular";
import { GenericModalComponent, GenericModalWithSubtitleComponent } from "@shared/components";
import { GenericModalSalirPaginaComponent } from "@shared/components/generic-modal-salir-pagina";
import { InformationModalComponent } from "@shared/components/information-modal/information-modal.component";
import { BehaviorSubject, Subject, from } from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class ModalService {
  public genericModal: any;
  public informationModal: any;
  modalSequenceCompleteAddBankAccount = new BehaviorSubject<boolean>(false);
  public clickAceptModal = new BehaviorSubject<boolean>(false);

  // Método para completar la secuencia de modales
  completeModalSequenceAddBankAccount() {
    this.modalSequenceCompleteAddBankAccount.next(true);
  }

  modalSequenceCompleted$ = this.modalSequenceCompleteAddBankAccount.asObservable();


  constructor(
    private readonly modal: ModalController,
    private readonly router: Router,
  ) { }

  public async openInformationModal(data: IInformationModal) {
    this.informationModal = await this.modal.create({
      component: InformationModalComponent,
      backdropDismiss: true,
      cssClass: "generic-modal",
      componentProps: {
        data,
      },
    });
    return await this.informationModal.present();
  }

  public async openGenericModal(data: IGenericModal) {
    const modal = await this.modal.create({
      component: GenericModalComponent,
      backdropDismiss: false,
      cssClass: "generic-modal",
      id: data.id ? data.id : "",
      componentProps: {
        data,
      },
    });
    return modal.present();
  }

  public async openGenericModalWithSubtitle(data: IGenericModal) {
    const modal = await this.modal.create({
      component: GenericModalWithSubtitleComponent,
      backdropDismiss: false,
      cssClass: "generic-modal-2",
      id: data.id ? data.id : "",
      componentProps: {
        data,
      },
    });
    return modal.present();
  }

  subject = new Subject<boolean>();

  public async openCustomModal(data: ModalOptions) {
    this.genericModal = await this.modal.create(data);
    await this.genericModal.present();

    const dismissPromise = this.genericModal.onDidDismiss();
    from(dismissPromise).subscribe(() => {
      this.subject.next(true);
    });

    return dismissPromise;
  }

  public closeModal(data?: unknown, role?: string) {
    return this.modal.dismiss(data, role);
  }

  unSelectBankAccount = () => {
    const radioGropu = document.querySelector<HTMLIonRadioElement>('#radioCuenta');
    const acordionCuenta = document.querySelector<any>('#acordionCuenta');
    if (radioGropu && acordionCuenta) {
      radioGropu.value = null;
      acordionCuenta.value = null;
    }
  };

  private async backToHomeCambioViaPago(): Promise<void> {
    await this.closeModal();
    this.router.navigate([
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_BASE,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_URL,
      ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO_HOME,
    ]);
  }
  public async cambioViaPagoExitModal() {
    await this.openGenericModal({
      id: EXIT_MODAL_CAMBIO_VIA_PAGO.id,
      title: EXIT_MODAL_CAMBIO_VIA_PAGO.title,
      primaryButtonText: EXIT_MODAL_CAMBIO_VIA_PAGO.primaryButtonText,
      secondaryButtonText: EXIT_MODAL_CAMBIO_VIA_PAGO.secondaryButtonText,
      logo: EXIT_MODAL_CAMBIO_VIA_PAGO.logo,
      primaryButtonCallback: () => { void this.backToHomeCambioViaPago(); },
      secondaryButtonCallback: () => { this.closeModal() },
      closeButtonCallback: () => { this.closeModal() },
    });
  }

  private async backToHomeCongelamientoSaldos(): Promise<void> {
    await this.closeModal();
    this.router.navigate([
      ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_BASE,
      ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_URL,
      ROUTING_CONGELAMIENTOS_SALDOS.CONGELAMIENTO_SALDOS_HOME,
    ]);
  }

  public async congelamientoSaldosExitModal() {
    await this.openGenericModal({
      id: EXIT_MODAL_CONGELAMIENTO_SALDOS.id,
      title: EXIT_MODAL_CONGELAMIENTO_SALDOS.title,
      primaryButtonText: EXIT_MODAL_CONGELAMIENTO_SALDOS.primaryButtonText,
      secondaryButtonText: EXIT_MODAL_CONGELAMIENTO_SALDOS.secondaryButtonText,
      logo: EXIT_MODAL_CONGELAMIENTO_SALDOS.logo,
      primaryButtonCallback: () => { void this.backToHomeCongelamientoSaldos(); },
      secondaryButtonCallback: () => { this.closeModal() },
      closeButtonCallback: () => { this.closeModal() },
    });
  }

  public async openModal(data: ModalOptions) {
    const modal = await this.modal.create(data);
    await modal.present();
    return modal;
  }

  public async datosPersonalesModal() {
    await this.openGenericModal({
      id: EXIT_MODAL_DATOS_PERSONALES.id,
      title: EXIT_MODAL_DATOS_PERSONALES.title,
      primaryButtonText: EXIT_MODAL_DATOS_PERSONALES.primaryButtonText,
      secondaryButtonText: EXIT_MODAL_DATOS_PERSONALES.secondaryButtonText,
      logo: EXIT_MODAL_DATOS_PERSONALES.logo,
      primaryButtonCallback: () => { void this.goToYourData(); },
      secondaryButtonCallback: () => { this.closeModal() },
      closeButtonCallback: () => { this.closeModal() },
    });
  }

  private async goToYourData(): Promise<void> {
    await this.closeModal();
    this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
  }

  public async openGenericModalMensajeSalida(
    tipoMensaje: TipoMensajeSalidaFlujoTramitePension
  ) {

    const baseData = MensajeSalidaFlujoTramitePension[tipoMensaje];

    const data: IGenericModal = {
      ...baseData,
      primaryButtonCallback: () => { void this.goToUrlSalida(baseData.id); },
      secondaryButtonCallback: () => { this.closeModal() },
      closeButtonCallback: () => { this.closeModal() },
    };

    const modal = await this.modal.create({
      component: GenericModalSalirPaginaComponent,
      backdropDismiss: false,
      cssClass: "generic-modal-2",
      id: data.id ?? "",
      componentProps: { data },
    });

    await modal.present();
  }

  private async goToVideoAtencion(): Promise<void> {
    await this.closeModal();
    this.router.navigate([`/${VIDEO_ATENCION}`]);
  }

  private async goToBeneficiario(): Promise<void> {
    await this.closeModal();
    this.router.navigate([DATA_UPDATE, BENEFICIARIES, HOME_URL]);
  }

  private async goToFundChange(): Promise<void> {
    await this.closeModal();
    this.router.navigate(["/", TRANSACTIONS, FUND_CHANGE_URL, ONBOARDING]);
  }

  private async goToEstimador(): Promise<void> {
    await this.closeModal();
    this.router.navigate(["/", URL_ESTIMADOR_PENSION]);
  }
  private async goToUrlSalida(id: string): Promise<void> {
    switch (id) {
      case TipoMensajeSalidaFlujoTramitePension.VideoAtencion:
        await this.goToVideoAtencion();
        break;
      case TipoMensajeSalidaFlujoTramitePension.ActualizaDatos:
        await this.goToYourData();
        break;
      case TipoMensajeSalidaFlujoTramitePension.Beneficiario:
        await this.goToBeneficiario();
        break;
      case TipoMensajeSalidaFlujoTramitePension.CambioFondo:
        await this.goToFundChange();
        break;
      case TipoMensajeSalidaFlujoTramitePension.Estimador:
        await this.goToEstimador();
        break;
      default:
        this.router.navigate([INICIO]);
    }
  }

}
